module.exports = __webpack_public_path__ + "img/king.823c40b7.svg";